interface downloadFileFromBlobProps {
  data: Blob;
  fileName: string;
  fileExtension: AllowedFileExtension;
}
export const downloadFileFromBlob = ({ data, fileName, fileExtension }: downloadFileFromBlobProps) => {
  const link = document.createElement('a');
  link.href = URL.createObjectURL(data);
  link.download = `${fileName}.${fileExtension}`;
  link.click();
  URL.revokeObjectURL(link.href);
};

export type AllowedFileExtension = 'pdf' | 'csv' | 'json' | 'jpeg' | 'png' | 'jpg' | 'mp4';
